// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { Toaster } from 'react-hot-toast';

// Context Providers
import { AuthProvider, useAuth } from './arca_Auth/AuthContext';
import { AlertProvider } from './components/common/AlertSystem';
import AppRoutes from './routes/AppRoutes';
import { useAuthNavigation } from './arca_Utilities/useAuthNavigation';

// Main App Content Component
const AppContent = () => {
  const { user } = useAuth();
  const { handleAuthSuccess, handleSignOut } = useAuthNavigation();

  return (
    <AppRoutes
      user={user}
      handleAuthSuccess={handleAuthSuccess}
      handleLogout={handleSignOut}
    />
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <AlertProvider>
            <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f0f9ff 0%, #dbeafe 50%, #e0e7ff 100%)' }}>
              <AppContent />

              {/* React Toastify */}
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />

              {/* React Hot Toast for Language Translator */}
              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 3000,
                  style: {
                    background: '#fff',
                    color: '#374151',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  },
                  success: {
                    iconTheme: {
                      primary: '#6B8E23',
                      secondary: '#fff',
                    },
                  },
                }}
              />
            </div>
          </AlertProvider>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
};

export default App;